module.exports = __webpack_public_path__ + "img/news.0df1934d.svg";